"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPayload = function (opts, defaultRequestFields) {
    return __assign(__assign({}, defaultRequestFields), opts);
};
exports.mapMassWithdrawalPayload = function (withdrawalArray, defaultFields) {
    var payload = withdrawalArray.reduce(function (ops, w, index) {
        ops["wd[wd" + (index + 1) + "][amount]"] = w.amount;
        ops["wd[wd" + (index + 1) + "][address]"] = w.address;
        ops["wd[wd" + (index + 1) + "][currency]"] = w.currency;
        if (w.dest_tag) {
            ops["wd[wd" + (index + 1) + "][dest_tag]"] = w.dest_tag;
        }
        return ops;
    }, {});
    return __assign(__assign({}, defaultFields), payload);
};
exports.mapGetTxMultiPayload = function (txArray, defaultFields) {
    var payload = { txid: txArray.join('|') };
    return __assign(__assign({}, defaultFields), payload);
};
